/* Global behaviours: native <dialog> triggers, scroll reveal. No dependencies. */
(() => {
  const openDialog = (dialog, trigger) => {
    if (!dialog || dialog.open) return;
    dialog.showModal();
    dialog._trigger = trigger;
    const focusTarget = dialog.querySelector('[autofocus], input[type="search"]');
    if (focusTarget) focusTarget.focus();
  };

  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-dialog-open]');
    if (opener) {
      openDialog(document.getElementById(opener.dataset.dialogOpen), opener);
      return;
    }
    const closer = event.target.closest('[data-dialog-close]');
    if (closer) {
      closer.closest('dialog')?.close();
      return;
    }
    // Clicking the backdrop (the dialog element itself) closes it.
    if (event.target instanceof HTMLDialogElement && event.target.open) event.target.close();
  });

  // Return focus to whatever opened the dialog.
  document.addEventListener(
    'close',
    (event) => {
      const dialog = event.target;
      if (dialog instanceof HTMLDialogElement && dialog._trigger) dialog._trigger.focus();
    },
    true
  );

  window.theme = window.theme || {};
  window.theme.openDialog = openDialog;

  // Scroll reveal: fades content in once. Content stays visible when JS or IntersectionObserver is unavailable.
  const items = document.querySelectorAll('[data-reveal]');
  if (!items.length) return;
  if (!('IntersectionObserver' in window)) {
    items.forEach((el) => el.classList.add('is-visible'));
    return;
  }
  const io = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        io.unobserve(entry.target);
      });
    },
    { rootMargin: '0px 0px -8% 0px' }
  );
  items.forEach((el) => io.observe(el));
})();
